import './Home.css';
import { Link } from 'react-router-dom';

export default function Home() {
  return (
    <div className="home-container">

      {/* HERO */}
      <section className="hero">
        <div className="hero-text">
          <h1>Create Beautiful, Lasting Memories</h1>
          <p>Custom photo books designed, printed, and delivered with love.</p>
          <Link to="/products" className="primary-btn">Explore Products</Link>
        </div>
      </section>

      {/* SERVICE HIGHLIGHT */}
      <section className="section two-column">
        <div className="text">
          <h2>Design Your Own Photobook</h2>
          <p>
            Whether it's a wedding, vacation, baby’s first year, or a heartfelt gift — we bring your vision to life. Choose layouts, colors, captions, and finishes that reflect your story.
          </p>
          <Link to="/contact" className="secondary-btn">Start Your Design</Link>
        </div>
        <div className="image">
          <img src="https://source.unsplash.com/600x400/?photobook,custom" alt="Custom Design" />
        </div>
      </section>

      {/* THEMES */}
      <section className="section themes">
        <h2>Choose a Theme That Tells Your Story</h2>
        <div className="theme-cards">
          <div className="card">
            <img src="https://source.unsplash.com/300x200/?wedding,album" alt="Wedding" />
            <h3>Wedding</h3>
          </div>
          <div className="card">
            <img src="https://source.unsplash.com/300x200/?baby,photo" alt="Baby" />
            <h3>Baby's First Year</h3>
          </div>
          <div className="card">
            <img src="https://source.unsplash.com/300x200/?travel,memories" alt="Travel" />
            <h3>Travel</h3>
          </div>
          <div className="card">
            <img src="https://source.unsplash.com/300x200/?family,reunion" alt="Family" />
            <h3>Family</h3>
          </div>
        </div>
      </section>

      {/* VIDEO PREVIEW */}
      <section className="section video-feature">
        <h2>Watch How It Works</h2>
        <div className="video-box">
          <iframe 
            width="100%" 
            height="400" 
            src="https://www.youtube.com/watch?v=keZd-PvEJhg" 
            title="How We Make Photobooks" 
            frameBorder="0" 
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" 
            allowFullScreen
          />
        </div>
      </section>

      {/* PHOTOBOOK GALLERY */}
      <section className="section gallery">
        <h2>Some of Our Favorite Creations</h2>
        <div className="gallery-grid">
          <img src="https://source.unsplash.com/400x300/?photo,book" alt="Sample 1" />
          <img src="https://source.unsplash.com/400x300/?photo,album" alt="Sample 2" />
          <img src="https://source.unsplash.com/400x300/?photo,prints" alt="Sample 3" />
          <img src="https://source.unsplash.com/400x300/?memory,photobook" alt="Sample 4" />
        </div>
      </section>

      {/* INSTAGRAM FEED STYLE GRID */}
      <section className="section insta-feed">
        <h2>Snapshots from Our Customers</h2>
        <div className="insta-grid">
          {Array.from({ length: 8 }).map((_, i) => (
            <img key={i} src={`https://source.unsplash.com/200x200/?photobook,${i}`} alt={`Insta ${i}`} />
          ))}
        </div>
      </section>

      {/* TESTIMONIAL TEASER */}
      <section className="section testimonials-preview">
        <h2>What Our Customers Say</h2>
        <div className="testimonial-cards">
          <div className="card">
            <p>"The perfect gift for our wedding guests. The quality blew us away!"</p>
            <strong>- Aditi</strong>
          </div>
          <div className="card">
            <p>"My travel photobook is a keepsake I’ll treasure forever."</p>
            <strong>- Rohan</strong>
          </div>
        </div>
        <Link to="/testimonials" className="secondary-btn">Read More Reviews</Link>
      </section>

      {/* FINAL CTA */}
      <section className="section cta-highlight">
        <h2>Ready to Start Yours?</h2>
        <p>Book a free consultation or visit our store to begin crafting your custom photobook today.</p>
        <Link to="/contact" className="primary-btn">Get in Touch</Link>
      </section>

    </div>
  );
}
